'use client';

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  edgeLambdaKeys,
  listSharedThreatReports,
  type ThreatReportSummary,
} from '@/shared/cors-edge-lambda-api';
import { useCellServiceSession } from './useCellServiceSession';

/** Reports shared with the case, newest first. */
export function useSharedThreatReports(
  caseId: string | undefined | null,
): UseQueryResult<ThreatReportSummary[], Error> {
  const { cellId, accessToken, enabled } = useCellServiceSession();
  const trimmedCaseId = caseId?.trim() || '';

  return useQuery<ThreatReportSummary[], Error>({
    queryKey: edgeLambdaKeys.threatReportShared(cellId, trimmedCaseId),
    queryFn: ({ signal }) =>
      listSharedThreatReports({
        cellId: cellId as string,
        accessToken: accessToken as string,
        caseId: trimmedCaseId,
        signal,
      }),
    enabled: enabled && Boolean(trimmedCaseId),
  });
}
